import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { auditApi } from '../../services/api';
import { formatTimestamp } from '../../utils/dateTime';

const AuditLogModal = ({ tableName, recordId, onClose }) => {
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    auditApi.getRecordHistory(tableName, recordId)
      .then(res => { if (!cancelled) setRows(res.data); })
      .catch(err => { if (!cancelled) setError(err?.response?.data?.error || 'Failed to load change history.'); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [tableName, recordId]);

  const identifier = rows[0]?.recordIdentifier || `#${recordId}`;
  const title = `Audit Trail — ${identifier}`;

  return (
    <div className="stui-modal-overlay">
      <div className="stui-modal stui-modal-lg">
        <div className="stui-modal-header">
          <h3>{title}</h3>
          <button className="stui-modal-close" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="stui-modal-body">
          {loading && <div className="stui-text-empty">Loading change history...</div>}

          {error && <div className="stui-text-empty stui-text-error">{error}</div>}

          {!loading && !error && rows.length === 0 && (
            <div className="stui-text-empty">No changes recorded for this record.</div>
          )}

          {!loading && !error && rows.length > 0 && (
            <table className="stui-inner-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User</th>
                  <th>Action</th>
                  <th>Field</th>
                  <th>Old Value</th>
                  <th>New Value</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(row => (
                  <tr key={row.id}>
                    <td className="stui-text-nowrap">{formatTimestamp(row.changedAt) || '—'}</td>
                    <td className="stui-td-muted">{row.changedBy}</td>
                    <td>
                      <span className={`stui-badge-audit stui-badge-audit-${(row.action || '').toLowerCase()}`}>
                        {row.action}
                      </span>
                    </td>
                    <td>{row.fieldName || <span className="stui-td-muted">—</span>}</td>
                    <td title={row.oldValue}>
                      {row.oldValue != null ? truncate(row.oldValue) : <span className="stui-td-muted">—</span>}
                    </td>
                    <td title={row.newValue}>
                      {row.newValue != null ? truncate(row.newValue) : <span className="stui-td-muted">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

function truncate(str, max = 25) {
  if (!str) return '';
  return str.length > max ? str.slice(0, max) + '…' : str;
}

export default AuditLogModal;
